import NewspaperIcon from "@mui/icons-material/Newspaper";
import React from "react";

const RecordingClass = [
  [
    "Recording Courses",
    "/admin/recording-class", 
    <NewspaperIcon sx={{ fontSize: "2rem", ml: "0.3rem" }}></NewspaperIcon>,
  ],
];

export default RecordingClass;
